(() => {
  const money = (cents, currency) => {
    const value = Number(cents || 0) / 100;
    try { return new Intl.NumberFormat(undefined, { style: 'currency', currency: currency || 'USD' }).format(value); }
    catch (_) { return `$${value.toFixed(2)}`; }
  };

  document.querySelectorAll('[data-oe-product]').forEach((root) => {
    const dataNode = root.querySelector('[data-oe-variants]');
    const selects = [...root.querySelectorAll('[data-oe-option]')];
    const idInput = root.querySelector('input[name="id"]');
    const price = root.querySelector('[data-oe-price]');
    const add = root.querySelector('[data-oe-add]');
    const gallery = root.querySelector('[data-oe-gallery]');
    if (!dataNode || !idInput) return;

    let variants = [];
    try { variants = JSON.parse(dataNode.textContent || '[]'); } catch (_) { return; }
    const currency = root.dataset.currency || 'USD';

    const sync = () => {
      const wanted = selects.map((select) => select.value);
      const variant = selects.length
        ? variants.find((candidate) => candidate.options && candidate.options.every((option, index) => option === wanted[index]))
        : variants[0];

      if (!variant) {
        if (add) { add.disabled = true; add.textContent = 'Unavailable'; }
        return;
      }

      const nextId = String(variant.id);
      if (idInput.value !== nextId) {
        idInput.value = nextId;
        idInput.dispatchEvent(new Event('change', { bubbles: true }));
      }

      if (price) {
        const compare = Number(variant.compare_at_price || 0);
        const current = Number(variant.price || 0);
        price.innerHTML = compare > current ? `<s>${money(compare, currency)}</s>${money(current, currency)}` : money(current, currency);
      }

      if (add) {
        add.disabled = !variant.available;
        add.textContent = variant.available ? 'Add to bag' : 'Sold out';
      }

      if (gallery && variant.featured_media_id) {
        const mediaId = String(variant.featured_media_id);
        const selectedMedia = [...gallery.querySelectorAll('[data-media-id]')].find((node) => node.dataset.mediaId === mediaId);
        if (selectedMedia && selectedMedia !== gallery.firstElementChild) gallery.prepend(selectedMedia);
      }
    };

    selects.forEach((select) => select.addEventListener('change', sync));
    sync();
  });

  document.querySelectorAll('[data-oe-guide]').forEach((root) => {
    const cards = [...root.querySelectorAll('[data-guide-card]')];
    const audienceButtons = [...root.querySelectorAll('[data-guide-audience]')];
    const budgetButtons = [...root.querySelectorAll('[data-guide-budget]')];
    const count = root.querySelector('[data-guide-count]');
    const empty = root.querySelector('[data-guide-empty]');
    let audience = 'all';
    let min = 0;
    let max = Infinity;

    const press = (buttons, active) => buttons.forEach((button) => button.setAttribute('aria-pressed', button === active ? 'true' : 'false'));
    const render = () => {
      let visible = 0;
      cards.forEach((card) => {
        const price = Number(card.dataset.price || 0);
        const show = (audience === 'all' || card.dataset.audience === audience) && price >= min && price <= max;
        card.hidden = !show;
        if (show) visible += 1;
      });
      if (count) count.textContent = `${visible} ${visible === 1 ? 'object' : 'objects'} in view`;
      if (empty) empty.hidden = visible !== 0;
    };

    audienceButtons.forEach((button) => button.addEventListener('click', () => {
      audience = button.dataset.guideAudience || 'all';
      press(audienceButtons, button);
      render();
    }));
    budgetButtons.forEach((button) => button.addEventListener('click', () => {
      min = Number(button.dataset.min || 0);
      max = button.dataset.max === 'inf' ? Infinity : Number(button.dataset.max || 0);
      press(budgetButtons, button);
      render();
    }));
    render();
  });
})();
